import { RhinoError } from '../error';
import { JSONValue } from '../util';

type Params = {
  url: string;
  method?: 'get' | 'post';
  headers?: Record<string, string>;
  body?: Record<string, JSONValue>;
  queryParams?: Record<string, string>;
  timeout?: number;
};

export async function request<Payload>(params: Params) {
  const { url, method, headers, body, queryParams, timeout } = params;
  const urlParams = queryParams ? `?${new URLSearchParams(queryParams)}` : '';
  let response: Response;

  try {
    const requestPromise = fetch(url + urlParams, {
      method: method ?? 'get',
      headers: new Headers({ 'content-type': 'application/json', ...headers }),
      ...(body !== undefined && { body: JSON.stringify(body) }),
    });

    response = await (timeout !== undefined ? requestWithTimeout(requestPromise, timeout) : requestPromise);
  } catch (e) {
    if (e instanceof RhinoError && e.code === 'TIMEOUT') throw e;

    throw new RhinoError('NETWORK_ERROR', undefined, { nativeError: e });
  }

  if (!response.ok) throw new RhinoError('NETWORK_REQUEST_ERROR', undefined, { response });

  return response.json() as Payload;
}

function requestWithTimeout(requestPromise: Promise<Response>, timeout: number) {
  return Promise.race<Response>([
    requestPromise,
    new Promise((resolve, reject) => {
      setTimeout(() => reject(new RhinoError('TIMEOUT')), timeout);
    }),
  ]);
}
